import { render, staticRenderFns } from "./AuthFailed.vue?vue&type=template&id=a781f650&scoped=true"
import script from "./AuthFailed.vue?vue&type=script&lang=js"
export * from "./AuthFailed.vue?vue&type=script&lang=js"
import style0 from "./AuthFailed.vue?vue&type=style&index=0&id=a781f650&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a781f650",
  null
  
)

export default component.exports